<template>
  <div class="editCompany">
    <!--公司信息-->
    <!--公司信息-->
    <el-form
      ref="editCompany"
      label-position="right"
      label-width="80px"
      :rules="rules"
      :model="detail"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('company.detail.companyCode')">
            <el-input v-model="detail.createCompanyCode" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('company.detail.companyStatus')">
            <el-input v-model="detail.currentStatusName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('company.detail.companyName')" prop="createCompanyName">
            <el-input
              v-model="detail.createCompanyName"
              clearable
              :maxlength="64"
              :placeholder="$t('company.companyNamePlaceholder')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('company.detail.companyAddress')" prop="companyAddress">
            <el-input
              v-model="detail.companyAddress"
              clearable
              :maxlength="256"
              :placeholder="$t('company.companyAddressPlaceholder')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('company.detail.companyNational')">
            <el-select
              class="inputWidth"
              filterable
              v-model="detail.companyNational"
              @change="selectCountry"
              :placeholder="$t('company.companyNationalPlaceholder')"
              clearable
            >
              <el-option
                style="width: 100%"
                v-for="item in country"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            class="propClass"
            :label="$t('company.detail.creditCode')"
            prop="creditCode"
          >
            <el-input
              v-model="detail.creditCode"
              :maxlength="32"
              :placeholder="$t('company.creditCodePlaceholder')"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('company.detail.companyIndex')" prop="sortOrder">
            <el-input-number
              v-model="detail.sortOrder"
              :controls="false"
              class="inputWidth"
              :min="0"
              :max="999"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="department-content">{{ this.$t('company.departmentTitle') }}</div>
    <!--新增/删除按钮-->
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          @click="insertEvent()"
          >{{ $t('xTable.insert') }}</vxe-button
        >
        <vxe-button
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          @click="deleteEvent()"
          >{{ $t('xTable.delete') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <!---可编辑表格-->
    <vxe-table
      border
      size="mini"
      show-overflow
      show-header-overflow
      ref="xTable"
      class="edit-table"
      :data="tableData"
      :edit-rules="validRules"
      :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
      @cell-click="cellClick"
    >
      <vxe-table-column type="checkbox" width="50"></vxe-table-column>
      <vxe-table-column type="seq" width="60" :title="$t('table.index')"></vxe-table-column>
      <vxe-table-column
        field="createDepartmentName"
        :title="$t('company.table.departmentName')"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-input
            style="width: 100%"
            clearable
            v-model="scope.row.createDepartmentName"
            :placeholder="$t('company.departmentPlaceholder')"
            @change="$refs.xTable.updateStatus(scope)"
          ></el-input>
        </template>
        <template v-slot="{ row }">{{ row.createDepartmentName }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="receiptClaimMode"
        :title="$t('company.detail.receiptClaimMode')"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="getSelectLabel(scope.row.receiptClaimMode, receiptClaimModeList) + ''"
            placement="bottom"
            :disabled="
              scope.row.receiptClaimMode == '' || scope.row.receiptClaimMode == null ? true : false
            "
          >
            <el-select
              style="width: 100%"
              v-model="scope.row.receiptClaimMode"
              filterable
              @change="$refs.xTable.updateStatus(scope)"
            >
              <el-option
                style="width: 100%"
                v-for="item in receiptClaimModeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{
          getSelectLabel(row.receiptClaimMode, receiptClaimModeList)
        }}</template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/masterData/company.js';
  import XEUtils from 'xe-utils';
  // import BASE_API from '@/api/dataBase.js';
  // import SiruiTable from '@/components/SiruiTable';
  // import { isEqual } from '@/common/js/util';

  export default {
    name: 'editCompany',
    components: {
      // SiruiTable,
    },
    data() {
      var specialValidate = (rule, value, callback) => {
        var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
        if (value != null && value.match(reg)) {
          callback(new Error(this.$t('menu.emoticons')));
        } else {
          callback();
        }
      };
      return {
        allDepartmentList: [],
        createDepartmentList: [],
        deleteDepartmentList: [],
        rules: {
          createCompanyName: [
            {
              required: true,
              message: this.$t('company.companyNameNotEmpty'),
              trigger: 'blur',
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
          companyAddress: [{ validator: specialValidate, trigger: ['blur', 'change'] }],
          companyNational: [
            {
              required: true,
              message: this.$t('company.companyNationalNotEmpty'),
              trigger: ['blur', 'change'],
            },
          ],
          creditCode: [
            {
              required: true,
              message: this.$t('company.creditCodeNotEmpty'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
        },
      };
    },
    props: {
      detail: {
        type: Object,
        default: () => {},
      },
      tableData: {
        type: Array,
        default: () => [],
      },
      receiptClaimModeList: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
        //获取定价规则值
        country(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'person_national').dictList;
          }
        },
      }),
      columnList() {
        return [
          {
            prop: 'controlAreaName',
            label: this.$t('company.table.controlareaName'),
          },
        ];
      },
      validRules() {
        return {
          crcreateDepartmentName: [
            { required: true, message: this.$t('company.departmentNameNotEmpty') },
          ],
        };
      },
    },
    mounted() {
      this.selectCountry();
    },
    methods: {
      //表格组件下拉框选择回调
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      initData() {
        if (this.$refs['editCompany']) {
          this.$refs['editCompany'].resetFields();
        }
        this.createDepartmentList = [];
        //初始化上级单位
        this.initDepartment();
      },
      //初始化部门
      initDepartment() {
        const params = {
          tenantCode: this.userInfo.userInfo.tenantCode,
        };
        this.$axios.post(API.GET_DEPARTMENT_LIST_API, params).then((res) => {
          if (0 == res.data.code) {
            this.allDepartmentList = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      selectCountry() {
        if (
          this.detail.companyNational == 'CN' ||
          this.detail.companyNational == 'MO' ||
          this.detail.companyNational == 'HK' ||
          this.detail.companyNational == 'ZH'
        ) {
          this.rules.creditCode[0].required = true;
        } else {
          this.rules.creditCode[0].required = false;
        }
      },
      //获取下拉数据
      remoteMethod(query) {
        if (query != '') {
          const params = {
            tenantCode: this.userInfo.userInfo.tenantCode,
            createDepartmentName: query,
          };
          this.$axios.post(API.GET_DEPARTMENT_LIST_API, params).then((res) => {
            if (0 == res.data.code) {
              this.createDepartmentList = res.data.data;
            } else {
              this.$alert(res.data.msg);
            }
          });
        } else {
          this.createDepartmentList = [];
        }
      },
      //新增一行
      insertEvent() {
        this.$refs.xTable.validate((valid) => {
          if (valid) {
            this.createDepartmentList = [];
            const record = {
              crcreateDepartmentName: null,
              receiptClaimMode: 'C',
            };
            this.$refs.xTable.insert(record).then(({ row }) => this.$refs.xTable.setActiveRow(row));
          }
        });
      },
      //删除一行
      deleteEvent() {
        let selectRecords = this.$refs.xTable.getCheckboxRecords();
        this.deleteDepartmentList = [];
        if (selectRecords.length) {
          //数据库查出的部门删除要记录id
          selectRecords.forEach((item) => {
            if (item.companyDepartmentName) {
              this.deleteDepartmentList.push(item.createDepartmentCode);
            }
          });
          this.$refs.xTable.removeSelecteds();
        } else {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        }
      },
      //
      cellClick() {
        this.createDepartmentList = this.allDepartmentList;
      },
      //根据code匹配出name
      // getSelectLabel(
      //   value,
      //   valueProp = "createDepartmentCode",
      //   labelField = "createDepartmentName"
      // ) {
      //   let item = XEUtils.find(
      //     this.allDepartmentList,
      //     item => item[valueProp] === value
      //   );
      //   return item ? item[labelField] + "(" + value + ")" : null;
      // },
      addSure(load) {
        // let xTableValidFlag = true;
        let createDepartmentList = [];
        // let status = false;
        //1.校验控制范围表格
        this.$refs.xTable.validate().then(() => {
          //只传新增的部门数据
          const tableList = this.$refs.xTable.getTableData().fullData;
          for (let i = 0; i < tableList.length; i++) {
            createDepartmentList.push({
              createDepartmentCode: tableList[i].createDepartmentCode || null,
              createDepartmentName: tableList[i].createDepartmentName,
              receiptClaimMode: tableList[i].receiptClaimMode,
            });
          }
          //判断重复要判断表格所有数据
          //2.判断是否有重复的数据
          if (tableList.length > 1) {
            let start = 1;
            let status = false;
            for (let n = 0; n < tableList.length; n++) {
              // if (status) {
              //   break;
              // }
              for (start; start < tableList.length; start++) {
                if (n != start) {
                  // status = isEqual(
                  //   tableList[n],
                  //   tableList[start],
                  //   "createDepartmentName"
                  // );
                  if (tableList[n].createDepartmentName == tableList[start].createDepartmentName) {
                    status = true;
                    if (status) {
                      this.$message({
                        showClose: true,
                        message: this.$t('company.departmentSameData'),
                        type: 'error',
                      });
                      return;
                    }
                    break;
                  }
                }
              }
              start = n;
            }
          }
          //4.校验form
          this.$refs['editCompany'].validate((valid) => {
            if (valid && !load) {
              this.$emit('setLoading', { loading: true });
              // this.detail.createDepartmentList = createDepartmentList.length == 0 ? null : JSON.stringify(createDepartmentList);
              this.detail.createDepartmentList = createDepartmentList;
              this.detail.deleteDepartmentList =
                this.deleteDepartmentList.length == 0 ? null : this.deleteDepartmentList;
              this.detail.updateDepartmentList = this.$refs.xTable.getUpdateRecords();
              this.$axios.post(API.UPDATE_COMPANY_API, this.detail).then((res) => {
                this.$emit('setLoading', { loading: false, edit: false });
                if (0 != res.data.code) {
                  this.$alert(res.data.msg);
                } else {
                  this.$emit('getData');
                  this.$message({
                    showClose: true,
                    message: res.data.msg || this.$t('message.success'),
                    type: 'success',
                  });
                }
              });
            } else {
              return false;
            }
          });
        });

        // this.$refs.xTable.validate(xTableValid => {
        //   xTableValidFlag = xTableValid;
        //   if (xTableValid) {
        //     //只传新增的部门数据
        //     const tableList = this.$refs.xTable.getTableData().fullData;
        //     for (let i = 0; i < tableList.length; i++) {
        //       createDepartmentList.push({
        //         createDepartmentCode: tableList[i].createDepartmentCode || null,
        //         createDepartmentName: tableList[i].createDepartmentName,
        //         receiptClaimMode:tableList[i].receiptClaimMode,
        //       });
        //     }
        //     //判断重复要判断表格所有数据
        //     //2.判断是否有重复的数据
        //     if (tableList.length > 1) {
        //       let start = 1;
        //       let status = false
        //       for (let n = 0; n < tableList.length; n++) {
        //         if (status) {
        //           break;
        //         }
        //         for (start; start < tableList.length; start++) {
        //           if (n != start) {
        //             // status = isEqual(
        //             //   tableList[n],
        //             //   tableList[start],
        //             //   "createDepartmentName"
        //             // );
        //             if (tableList[n].createDepartmentName == tableList[start].createDepartmentName) {
        //               status = true
        //               if (status) {
        //                 this.$message({
        //                   showClose: true,
        //                   message: this.$t("company.departmentSameData"),
        //                   type: "error"
        //                 });
        //                 return;
        //               }
        //             }
        //           }
        //         }
        //         start = n;
        //       }
        //     }
        //     //4.校验form
        //     this.$refs["editCompany"].validate(valid => {
        //       if (valid && !load) {
        //         this.$emit("setLoading", { loading: true });
        //         // this.detail.createDepartmentList = createDepartmentList.length == 0 ? null : JSON.stringify(createDepartmentList);
        //         this.detail.createDepartmentList = createDepartmentList;
        //         this.detail.deleteDepartmentList = this.deleteDepartmentList.length == 0 ? null : this.deleteDepartmentList;
        //         this.detail.updateDepartmentList = this.$refs.xTable.getUpdateRecords();
        //         this.$axios
        //           .post(API.UPDATE_COMPANY_API, this.detail)
        //           .then(res => {
        //             this.$emit("setLoading", { loading: false, edit: false });
        //             if (0 != res.data.code) {
        //               this.$alert(res.data.msg);
        //             } else {
        //               this.$emit("getData");
        //               this.$message({
        //                 showClose: true,
        //                 message: res.data.msg || this.$t("message.success"),
        //                 type: "success"
        //               });
        //             }
        //           });
        //       } else {
        //         return false;
        //       }
        //     });
        //   }
        // });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .department-content {
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(40, 55, 79, 1);
  }
  .control-content {
    margin-top: 15px;
    margin-bottom: 10px;
  }
</style>
